import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { lastChangeCopySelector } from '../../selectors';
const lastEditedContainerCss = "lp40a3n";
const LastEditedContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(lastEditedContainerCss, props.className)} />;
});
export const LastEdited = () => {
  const lastChanged = useSelector(lastChangeCopySelector);
  if (!lastChanged) return null;
  return <LastEditedContainer>
      <BodyText size="medium" color="muted">
        {lastChanged}
      </BodyText>
    </LastEditedContainer>;
};

require("./last_edited.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./last_edited.js");